import React from "react";

import "./Copyright.scss";

const Copyright = () => {
  return (
    <div className="footerLogin">
      <div className="copyright">
        © Attijari Leasing {new Date().getFullYear()} | Développé par{" "}
        <a href="https://www.medianet.tn/fr/" target="_blank" rel="noreferrer">
          MEDIANET
        </a>
      </div>
    </div>
  );
};

export default Copyright;
